import { __extends } from "tslib";
import { ErrorEvent } from './ErrorEvent';
var AsyncErrorEvent = /** @class */ (function (_super) {
    __extends(AsyncErrorEvent, _super);
    function AsyncErrorEvent(type, bubbles, cancelable, text, error) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (text === void 0) { text = ''; }
        if (error === void 0) { error = null; }
        var _this = _super.call(this, type, bubbles, cancelable, text) || this;
        _this.$Bgerror = error;
        return _this;
    }
    Object.defineProperty(AsyncErrorEvent.prototype, "error", {
        get: function () {
            return this.$Bgerror;
        },
        enumerable: false,
        configurable: true
    });
    AsyncErrorEvent.prototype.clone = function () {
        return new AsyncErrorEvent(this._type, this._bubbles, this._cancelable, this._text, this.$Bgerror);
    };
    AsyncErrorEvent.prototype.toString = function () {
        return this.formatToString('AsyncErrorEvent', 'type', 'bubbles', 'cancelable', 'eventPhase', 'text', 'error');
    };
    AsyncErrorEvent.ASYNC_ERROR = 'asyncError';
    AsyncErrorEvent.classInitializer = null;
    return AsyncErrorEvent;
}(ErrorEvent));
export { AsyncErrorEvent };
